import React, { useRef, useState, useEffect, useMemo } from "react";
import { useAppSelector, useAppDispatch } from "Redux/hooks";
import { removeBgBorder } from "Constants/general";
import fench from "../../../../assets/img/order__page/fench.png";
import steelTypeIcon from "../../../../assets/img/icon/steeltype-new.svg";
import infoIcon from "../../../../assets/img/icon/info.svg";
import {
  lastNetsWithoutPrice,
  lastNetsWithPrice,
  netsWithoutPrice,
  netsWithPrice,
} from "Constants/net-constants";
import { useTranslation } from "react-i18next";
import { Overlay, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getCurrentOrderNets } from "Redux/middlwares/order";

import {
  closestCenter,
  DndContext,
  DragOverlay,
  KeyboardSensor,
  MouseSensor,
  TouchSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import { restrictToVerticalAxis } from "@dnd-kit/modifiers";
import {
  arrayMove,
  SortableContext,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import InfiniteScroll from "react-infinite-scroll-component";
import BarLoader from "react-bar-loader";
import DraggableTableRows from "./DraggableTableRows";
import StaticTableRow from "./StaticTableRow";
import DraggableHeaderRow from "../DraggableHeaderRow";
import { getOrderStats } from "Services/order";
import { NET_SUBCLASS_TYPE } from "Constants/net-constants";

import "../index.scss";

const NetsTable = ({
  priceShow,
  openItemModal,
  selectedTool,
  setSelectedTool,
  handleImagePreview,
  netPrice,
  copyOrderItem,
  handleUpdate,
  deleteTool,
  setNetsData,
  netsData,
  checkRowNums,
  edit,
  editOrderId,
  headers,
  onHeadersChange,
}: any) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation(["newOrder", "common", "measurements", "tool"]);
  const currentOrderNets = useAppSelector(
    (state) => state.net.currentOrderNets
  );
  const rightToLeft = useAppSelector((state) => state.root.rightToLeft);

  const nextOrderNetsPage = useAppSelector((state) => state.net.orderNetPage);

  const [showMeasureTooltip, setShowMeasureTooltip] = useState(false);
  const [showNetTypeTooltip, setShowNetTypeTooltip] = useState(false);

  const [activeId, setActiveId] = useState();
  const [activeIndex, setActiveIndex] = useState();
  const [hasMore, setHasMore] = useState(false);

  const [isMouseOver, setIsMouseOver] = useState(false);
  const [mousePosition, setMousePosition] = useState(0);
  const [inProgress, setInProgress] = useState(false);
  const [netTons, setNetTons] = useState(0);
  const [netUnits, setNetUnits] = useState(0);
  const [tableRows, setTableRows] = useState<any[]>([]);

  const measurementRef = useRef(null);
  const netTypeRef = useRef(null);
  const NetsPositionRef = useRef(null);
  const NetsTableRef = useRef(null);

const insertHeadersIntoRows = (
  itemRows: any[],
  sectionHeaders: any[] = []
) => {
  const mergedRows = [...itemRows];

  [...sectionHeaders]
    .sort(
      (firstHeader, secondHeader) =>
        firstHeader.position -
        secondHeader.position
    )
    .forEach((header) => {
      const position = Math.max(
        0,
        Math.min(
          header.position,
          mergedRows.length
        )
      );

      mergedRows.splice(position, 0, {
        ...header,
        type: "header",
        sectionType: "net",
        isNew: header.isNew ?? false,
        isEditing:
          header.isEditing ?? false,
      });
    });

  return mergedRows;
};

const getHeadersFromRows = (
  rows: any[]
) => {
  return rows
    .map((row, position) => {
      if (row.type !== "header") {
        return null;
      }

      return {
        ...row,
        type: "header",
        sectionType: "net",
        position,
      };
    })
    .filter(Boolean);
};

const commitTableRows = (
  nextRows: any[]
) => {
  setTableRows(nextRows);

  onHeadersChange?.(
    getHeadersFromRows(nextRows)
  );
};

  useEffect(() => {
    getOrderStats(NET_SUBCLASS_TYPE, editOrderId)
      .then((res) => {
        setNetUnits(res.data.total_quantity)
        setNetTons((res.data.total_weight/1000).toFixed(2) )
      });
  }, [currentOrderNets, editOrderId]);

      useEffect(() => {
    if (currentOrderNets) {
      setNetsData(currentOrderNets);
      if (nextOrderNetsPage !== false) {
        setHasMore(true);
      } else {
        setHasMore(false);
      }
    }
  }, [currentOrderNets]);

useEffect(() => {
  if (!netsData) {
    return;
  }

  if (
    edit &&
    headers?.length > 0 &&
    netsData.length === 0
  ) {
    return;
  }

  const itemRows = netsData.map(
    (net) => ({
      id: `net-${net.id}`,
      type: "net",
      itemId: net.id,
      data: net,
    })
  );

  setTableRows(
    insertHeadersIntoRows(
      itemRows,
      headers || []
    )
  );
}, [
  netsData,
  headers,
  edit,
]);

  const selectedDragRow = useMemo(() => {
  if (!activeId) {
    return null;
  }

  return tableRows.find((row) => row.id === activeId) || null;
}, [activeId, tableRows]);

const sensors = useSensors(
  useSensor(MouseSensor, {
    activationConstraint: {
      distance: 7,
    },
  }),
  useSensor(TouchSensor, {
    activationConstraint: {
      delay: 180,
      tolerance: 6,
    },
  }),
  useSensor(KeyboardSensor, {})
);


const handleAddHeader = () => {
  if (!selectedTool?.id) {
    return;
  }

  const newHeader = {
    id: `net-header-${Date.now()}-${Math.random()
      .toString(36)
      .slice(2, 8)}`,
    type: "header",
    sectionType: "net",
    title: "",
    supplierNote: "",
    position: 0,
    isNew: true,
    isEditing: true,
  };

  const selectedIndex =
    tableRows.findIndex(
      (row) =>
        row.type === "net" &&
        String(row.itemId) ===
          String(selectedTool.id)
    );

  const updatedRows = [...tableRows];

  if (selectedIndex === -1) {
    updatedRows.push(newHeader);
  } else {
    updatedRows.splice(
      selectedIndex,
      0,
      newHeader
    );
  }

  commitTableRows(updatedRows);
  setIsMouseOver(false);
};

const handleHeaderChange = (
  headerId,
  changes
) => {
  const updatedRows = tableRows.map(
    (row) =>
      row.id === headerId
        ? {
            ...row,
            ...changes,
          }
        : row
  );

  commitTableRows(updatedRows);
};


const handleDeleteHeader = (
  headerId
) => {
  const updatedRows = tableRows.filter(
    (row) => row.id !== headerId
  );

  commitTableRows(updatedRows);
};

  function handleDragStart(event) {
      const draggedId = event.active.id;
      const draggedIndex = tableRows.findIndex(
        (row) => row.id === draggedId
      );

      setActiveId(draggedId);
      setActiveIndex(draggedIndex);
    }

    function handleDragEnd(event) {
    const { active, over } = event;

    if (!over) {
      setActiveId(null);
      setActiveIndex(null);
      return;
    }

    if (active.id === over.id) {
      setActiveId(null);
      setActiveIndex(null);
      return;
    }

    const oldIndex = tableRows.findIndex(
      (row) => row.id === active.id
    );

    const newIndex = tableRows.findIndex(
      (row) => row.id === over.id
    );

    if (oldIndex === -1 || newIndex === -1) {
      setActiveId(null);
      setActiveIndex(null);
      return;
    }

    const previousNetOrder = tableRows
      .filter((row) => row.type === "net")
      .map((row) => row.data);

    const movedRows = arrayMove(tableRows, oldIndex, newIndex);

    const nextNetOrder = movedRows
      .filter((row) => row.type === "net")
      .map((row) => row.data);

    commitTableRows(movedRows);

    const draggedRow = tableRows[oldIndex];

    if (draggedRow?.type === "net") {
      const previousNetIndex = previousNetOrder.findIndex(
        (net) => String(net.id) === String(draggedRow.itemId)
      );

      const nextNetIndex = nextNetOrder.findIndex(
        (net) => String(net.id) === String(draggedRow.itemId)
      );

      if (previousNetIndex !== nextNetIndex) {
        setNetsData(nextNetOrder);

        checkRowNums(
          previousNetIndex,
          nextNetIndex,
          nextNetOrder,
          NET_SUBCLASS_TYPE
        );
      }
    }

    setActiveId(null);
    setActiveIndex(null);
  }

  function handleDragCancel() {
    setActiveId(null);
  }

  const onloadFunction = async () => {
    try {
      if (nextOrderNetsPage !== false && nextOrderNetsPage > 1) {
        if (edit) {
          await dispatch(getCurrentOrderNets(edit, editOrderId, nextOrderNetsPage));
        } else {
          await dispatch(getCurrentOrderNets(edit, 0, nextOrderNetsPage));
        }
      }
    } catch (error) {
      setHasMore(false);
    }
  };

  useEffect(() => {
    const icon = NetsPositionRef.current;
    const table = NetsTableRef.current;
    if (isMouseOver && icon && table) {
      const rect = icon.getBoundingClientRect();
      const top = rect.top + window.pageYOffset;
      const tab = table.getBoundingClientRect();
      const tabtop = tab.top + window.pageYOffset;
      setMousePosition(top - tabtop);
    }
  }, [isMouseOver]);

  return (
    <section id="nets__table" className="order__tables mt-xl-4">
      <div className="container p-0">
        <div className="table__wrapper">
          {/* <!-- table header  --> */}
          <div className="table__header d-flex flex-row">
            {/* <!-- table title  --> */}
            <div className="table__title d-flex align-items-center justify-content-center">
              <h2 className="text-center text-white text-uppercase m-0">
                {t("Nets")}
              </h2>
            </div>
            <div
              className="table__tit__btn d-flex align-items-center justify-content-center"
              style={{ cursor: "pointer" }}
              onClick={() => openItemModal(2)}
            >
              <span className="text-white bg-danger text-center text-uppercase">
                {t("add new net", { ns: "newOrder" })}
              </span>
            </div>
          </div>
          {/* <!-- real table  --> */}
          <DndContext
            sensors={sensors}
            onDragEnd={handleDragEnd}
            onDragStart={handleDragStart}
            onDragCancel={handleDragCancel}
            collisionDetection={closestCenter}
            modifiers={[restrictToVerticalAxis]}
          >
            <table
              className={
                "table table mb-0 custom-tool-table " +
                (rightToLeft ? "rightToLeft" : "")
              }
              style={{ position: "relative" }}
              ref={NetsTableRef}
            >
              {/* <!-- table head title section  --> */}
              <thead>
                <tr style={priceShow ? netsWithPrice : netsWithoutPrice}>
                  <th
                    scope="col"
                    className="text-capitalize d-flex justify-content-center align-items-center p-0"
                  >
                    {t("row", { ns: "common" })}
                  </th>
                  <th
                    scope="col"
                    className={
                      "text-capitalize d-flex justify-content-center align-items-center p-0 " +
                      (rightToLeft ? "dark-border-right" : "dark-border-left")
                    }
                  >
                    {t("sketch", { ns: "newOrder" })}
                  </th>
                  <th
                    scope="col"
                    className={
                      "text-capitalize d-flex align-items-center justify-content-start text-center " +
                      (rightToLeft ? "dark-border-right" : "dark-border-left")
                    }
                  >
                    {t("Name", { ns: "newOrder" })}
                  </th>
                  <th
                    scope="col"
                    className={
                      "text-capitalize d-flex align-items-center justify-content-center text-center sm__wrap p-0 " +
                      (rightToLeft ? "dark-border-right" : "dark-border-left")
                    }
                  >
                    <img
                      className="hei__icon"
                      src={steelTypeIcon}
                      alt="hei icon"
                      style={{
                        height: "20px",
                        width: "15px",
                      }}
                    />
                    <span className="d-flex align-items-start">
                      <p className={"ml-1 mr-1"}>
                        {rightToLeft
                          ? t("type", { ns: "common" })
                          : t("steel", { ns: "newOrder" })}
                      </p>
                      <p>
                        {rightToLeft
                          ? t("steel", { ns: "newOrder" })
                          : t("type", { ns: "common" })}
                      </p>
                    </span>
                  </th>
                  <th
                    scope="col"
                    className={
                      "text-capitalize d-flex align-items-center justify-content-start text-center sm__wrap " +
                      (rightToLeft ? "dark-border-right" : "dark-border-left")
                    }
                  >
                    <span className={rightToLeft ? "ml-3" : "mr-3"}>
                      {t("measurements", { ns: "tool" })}
                    </span>
                    <img
                      src={infoIcon}
                      style={{
                        width: "19px",
                        height: "19px",
                        cursor: "pointer",
                      }}
                      alt="info"
                      ref={measurementRef}
                      onMouseEnter={() => setShowMeasureTooltip(true)}
                      onMouseLeave={() => setShowMeasureTooltip(false)}
                    />
                    <Overlay
                      target={measurementRef.current}
                      show={showMeasureTooltip}
                      placement="top"
                    >
                      {(props) => (
                        <Tooltip id="overlay-example-2" {...props}>
                          {t("previewMeasInfo", { ns: "newOrder" })}
                        </Tooltip>
                      )}
                    </Overlay>
                  </th>
                  <th
                    scope="col"
                    className={
                      "text-capitalize d-flex align-items-center justify-content-start text-center " +
                      (rightToLeft ? "dark-border-right" : "dark-border-left")
                    }
                  >
                    <span className={rightToLeft ? "ml-2" : "mr-2"}>
                      {t("net type", { ns: "tool" })}
                    </span>
                    <img
                      src={infoIcon}
                      style={{
                        width: "19px",
                        height: "19px",
                        cursor: "pointer",
                      }}
                      alt="info"
                      ref={netTypeRef}
                      onMouseEnter={() => setShowNetTypeTooltip(true)}
                      onMouseLeave={() => setShowNetTypeTooltip(false)}
                    />
                    <Overlay
                      target={netTypeRef.current}
                      show={showNetTypeTooltip}
                      placement="top"
                    >
                      {(props) => (
                        <Tooltip id="overlay-example-2" {...props}>
                          {t("previewNetsInfo", { ns: "newOrder" })}
                        </Tooltip>
                      )}
                    </Overlay>
                  </th>
                  <th
                    scope="col"
                    className={
                      "text-capitalize d-flex align-items-center justify-content-start text-center " +
                      (rightToLeft ? "dark-border-right" : "dark-border-left")
                    }
                  >
                    {t("quantity", { ns: "common" })}
                  </th>
                  <th
                    scope="col"
                    className="text-capitalize dark-border-right dark-border-left"
                    style={{ padding: "0px" }}
                  >
                    <div className="two__rows_sec">
                      <div className="top__sec">
                        <span>{t("weight", { ns: "common" })}</span>
                      </div>
                      <div
                        className={
                          "d-flex justify-content-start align-items-center bottom_sec h-100 pb-1 " +
                          (rightToLeft
                            ? "bottom_sec-pr text-right"
                            : "bottom_sec-pl text-left")
                        }
                      >
                        <span style={{ width: "50%" }}>
                          {t("unit", { ns: "common" })}
                        </span>
                        <span>{t("total", { ns: "common" })}</span>
                      </div>
                    </div>
                  </th>
                  {priceShow && (
                    <>
                      <th
                        scope="col"
                        className="text-capitalize d-flex align-items-start justify-content-start text-center flex-column"
                      >
                        <span>{t("unit", { ns: "common" })}</span>
                        <span>
                          <span>{t("Price", { ns: "common" })}</span>
                          <span className="unit__sm">(NIS)</span>
                        </span>
                      </th>
                      <th
                        scope="col"
                        className="text-capitalize d-flex align-items-start justify-content-start text-center flex-column"
                      >
                        <span>{t("total", { ns: "common" })}</span>
                        <span>
                          <span>{t("Price", { ns: "common" })}</span>
                          <span className="unit__sm">(NIS)</span>
                        </span>
                      </th>
                    </>
                  )}
                </tr>
              </thead>
              {/* <!-- table body data section  --> */}
              <tbody
                style={
                  currentOrderNets.length > 9
                    ? {
                        height: "720px",
                        overflow: "auto",
                        display: "block",
                        scrollbarWidth: "none",
                      }
                    : {
                      scrollbarWidth: "none",
                    }
                }
                id="scrollableNetsTable"
              >
                <SortableContext
                    items={tableRows.map((row) => row.id)}
                    strategy={verticalListSortingStrategy}
                  >
                  <InfiniteScroll
                    dataLength={netsData.length}
                    next={onloadFunction}
                    hasMore={hasMore}
                    loader={<BarLoader color="#F84343" height="4" />}
                    scrollableTarget="scrollableNetsTable"
                    style={{
                      scrollbarWidth: "none",
                    }}
                  >
                    {/* <!-- table data row   --> */}
                    {tableRows.map((row, index) => {
                    if (row.type === "header") {
                      return (
                        <DraggableHeaderRow
                          key={row.id}
                          id={row.id}
                          header={row}
                          priceShow={priceShow}
                          onChange={handleHeaderChange}
                          onDelete={handleDeleteHeader}
                        />
                      );
                    }

                    return (
                      <DraggableTableRows
                        index={index}
                        key={row.id}
                        id={row.id}
                        itemNet={row.data}
                        priceShow={priceShow}
                        handleImagePreview={handleImagePreview}
                        setSelectedTool={setSelectedTool}
                        setIsMouseOver={setIsMouseOver}
                        NetsPositionRef={NetsPositionRef}
                      />
                    );
                  })}
                  </InfiniteScroll>
                </SortableContext>
              </tbody>
              <tbody className="last">
                <tr
                  style={priceShow ? lastNetsWithPrice : lastNetsWithoutPrice}
                >
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td style={removeBgBorder}></td>
                  <td className="justify-content-center p-0">{netUnits}</td>
                  <td className="justify-content-center p-0" colSpan={2}>
                    {netTons}
                  </td>
                  {priceShow && <td colSpan={2}>{netPrice}</td>}
                </tr>
                <tr
                  style={priceShow ? lastNetsWithPrice : lastNetsWithoutPrice}
                >
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td style={removeBgBorder}></td>
                  <td className="justify-content-center p-0">
                    {t("units", { ns: "common" })}
                  </td>
                  <td
                    className="justify-content-center p-0"
                    colSpan={2}
                    style={{ textTransform: "capitalize" }}
                  >
                    {t("weight", { ns: "common" })} (
                    {t("ton", { ns: "measurements" })})
                  </td>
                  {priceShow && (
                    <td colSpan={2}>{t("Price", { ns: "common" })} (NIS)</td>
                  )}
                </tr>
              </tbody>
              {isMouseOver && !inProgress && (
                <div
                  className="dropdown-content"
                  style={
                    rightToLeft
                      ? { top: `${mousePosition}px`, right: "45px" }
                      : { top: `${mousePosition}px`, left: "45px" }
                  }
                  onMouseEnter={(e) => {
                    setIsMouseOver(true);
                  }}
                  onMouseLeave={() => setIsMouseOver(false)}
                >
                  <div className="drop-item" onClick={handleAddHeader}>
                    <FontAwesomeIcon
                      className={
                        "item-icon " + (rightToLeft ? "item-ml" : "item-mr")
                      }
                      icon="plus"
                    />

                    <span>הוספת כותרת</span>
                  </div>
                  <div
                    className="drop-item"
                    onClick={async () => {
                      setIsMouseOver(false);
                      setInProgress(true);
                      copyOrderItem().then(() => {
                        setInProgress(false);
                      });
                    }}
                  >
                    <FontAwesomeIcon
                      className={
                        "item-icon " + (rightToLeft ? "item-ml" : "item-mr")
                      }
                      icon="copy"
                    ></FontAwesomeIcon>
                    <span>{t("Duplicate", { ns: "newOrder" })}</span>
                  </div>
                  <div className="drop-item" onClick={handleUpdate}>
                    <FontAwesomeIcon
                      className={
                        "item-icon " + (rightToLeft ? "item-ml" : "item-mr")
                      }
                      icon="pencil-alt"
                    ></FontAwesomeIcon>
                    <span>{t("edit", { ns: "common" })}</span>
                  </div>
                  <div className="drop-item" onClick={deleteTool}>
                    <FontAwesomeIcon
                      className={
                        "item-icon " + (rightToLeft ? "item-ml" : "item-mr")
                      }
                      icon="trash"
                    ></FontAwesomeIcon>
                    <span>{t("Delete", { ns: "common" })}</span>
                  </div>
                </div>
              )}
            </table>
            <DragOverlay>
              {selectedDragRow?.type === "net" && (
                <table
                  className={
                    "table table mb-0 custom-tool-table" +
                    (rightToLeft ? " rightToLeft" : "")
                  }
                >
                  <tbody>
                    <StaticTableRow
                      id={selectedDragRow.id}
                      index={activeIndex}
                      itemNet={selectedDragRow.data}
                      priceShow={priceShow}
                      setSelectedTool={setSelectedTool}
                      handleImagePreview={handleImagePreview}
                    />
                  </tbody>
                </table>
              )}

              {selectedDragRow?.type === "header" && (
                <div className="order-header-drag-overlay">
                  <span>
                    {selectedDragRow.title || "כותרת חדשה"}
                  </span>
                </div>
              )}
            </DragOverlay>
          </DndContext>
        </div>
      </div>
    </section>
  );
};

export default NetsTable;
